import React from 'react';
import { Field, reduxForm } from 'redux-form';

import { RadioButtonGroup } from 'redux-form-material-ui';
import { RadioButton } from 'material-ui/RadioButton';
import FlatButton from 'material-ui/FlatButton';

import { RenderError } from 'components/shared/RenderError';
import validate from '../validate';
import * as validator from 'helpers/Validator';

import { AccentColor } from 'helpers/AccentColorHelper';
import { BooleanRadioButtons } from 'helpers/BooleanRadioButtons';

import { hostIsBgoResidents } from 'helpers/CurrentWindowLocation';

import scrollIntoView from 'scroll-into-view';

const style = {
  button: {
    color: 'white',
    float: 'right',
    height: '40px',
  },
  backButton: {
    float: 'left',
    color: AccentColor(),
    height: '40px',
  },
};

const WizardFormForthPage = (props) => {
  const { handleSubmit, previousPage } = props;
  return (
    <div id="top" style={{ marginTop: '50px' }}>
      <h3
        style={{
          fontSize: '30px',
          marginBottom: '10px',
          fontFamily: 'Circular-Bold',
        }}
      >
        {hostIsBgoResidents()
          ? 'Have you rented from us before?'
          : 'We have a few quick questions for you.'}
      </h3>
      <form onSubmit={handleSubmit}>
        {hostIsBgoResidents() && (
          <BooleanRadioButtons
            name="has_previously_rented"
            style={{ width: '187px', margin: 'auto', marginTop: '16px' }}
            validate={[validator.required]}
          />
        )}
        {!hostIsBgoResidents() && (
          <div className="row" style={{ marginBottom: '70px' }}>
            <h5 style={{ textAlign: 'center', marginBottom: '15px' }}>
              Have you ever been evicted from a tenancy or left owing money?
            </h5>
            <Field
              name="evicted"
              component={RadioButtonGroup}
              style={{ width: '187px', margin: 'auto' }}
            >
              <RadioButton
                value="Yes"
                label="Yes"
                style={{ width: '102px', display: 'inline-flex', fontSize: '16px' }}
              />
              <RadioButton
                value="No"
                label="No"
                style={{ width: '70px', display: 'inline-flex', float: 'right', fontSize: '16px' }}
              />
            </Field>
            <Field name="evicted" component={RenderError} />

            <h5 style={{ textAlign: 'center', marginBottom: '15px' }}>
              Have you ever been part of a landlord/tenant hearing?
            </h5>
            <Field
              name="tenantHearing"
              component={RadioButtonGroup}
              style={{ width: '187px', margin: 'auto' }}
            >
              <RadioButton
                value="Yes"
                label="Yes"
                style={{ width: '102px', display: 'inline-flex', fontSize: '16px' }}
              />
              <RadioButton
                value="No"
                label="No"
                style={{ width: '70px', display: 'inline-flex', float: 'right', fontSize: '16px' }}
              />
            </Field>
            <Field name="tenantHearing" component={RenderError} />

            <h5 style={{ textAlign: 'center', marginBottom: '15px' }}>
              Have you ever been convicted of a crime or felony?
            </h5>
            <Field
              name="crime"
              component={RadioButtonGroup}
              style={{ width: '187px', margin: 'auto' }}
            >
              <RadioButton
                value="Yes"
                label="Yes"
                style={{ width: '102px', display: 'inline-flex', fontSize: '16px' }}
              />
              <RadioButton
                value="No"
                label="No"
                style={{ width: '70px', display: 'inline-flex', float: 'right', fontSize: '16px' }}
              />
            </Field>
            <Field name="crime" component={RenderError} />

            <h5 style={{ textAlign: 'center', marginBottom: '15px' }}>
              Have you ever declared personal bankruptcy?
            </h5>
            <Field
              name="bankruptcy"
              component={RadioButtonGroup}
              style={{ width: '187px', margin: 'auto' }}
            >
              <RadioButton
                value="Yes"
                label="Yes"
                style={{ width: '102px', display: 'inline-flex', fontSize: '16px' }}
              />
              <RadioButton
                value="No"
                label="No"
                style={{ width: '70px', display: 'inline-flex', float: 'right', fontSize: '16px' }}
              />
            </Field>
            <Field name="bankruptcy" component={RenderError} />

            <h5 style={{ textAlign: 'center', marginBottom: '15px' }}>
              Have you rented with us before?
            </h5>
            <BooleanRadioButtons
              name="has_previously_rented"
              style={{ width: '187px', margin: 'auto' }}
              validate={[validator.required]}
            />
          </div>
        )}

        <div id="application_footerbar">
          <div style={{ textAlign: 'center', maxWidth: '600px', margin: 'auto' }}>
            <FlatButton
              label="Back"
              type="button"
              className="previous"
              onClick={previousPage}
              backgroundColor="#fff"
              hoverColor="grey"
              style={style.backButton}
            />
            <FlatButton
              label="Next"
              type="submit"
              className="next"
              primary={true}
              backgroundColor={AccentColor()}
              hoverColor="grey"
              style={style.button}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default reduxForm({
  form: 'wizard',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
  onSubmitFail: (errors) => {
    scrollIntoView(document.getElementById('errorMessage'), {
      time: 500,
      align: {
        top: 0.25,
      },
    });
  },
})(WizardFormForthPage);
